/**
 * Set by withNuncheeSession on responses where the request ARRIVED with a user
 * access token but was answered by the anonymous fallback session (refresh
 * definitively rejected, or invalid token with no refresh token). Never set
 * for genuinely anonymous visitors (no token at all).
 *
 * Lets server-side callers that KNOW the session is logged-in (SSR prefetches
 * in prepareAppState) detect a degraded answer even when the backend responds
 * 200 with empty data instead of a no-user error (42215) — see
 * fetchActiveOrders' throwOnNoUser.
 */
export const SESSION_ANON_FALLBACK_HEADER = 'x-session-anon-fallback'

/**
 * Backend code for "no user on this session". `withNuncheeSession` falls back
 * to an anonymous session when a token refresh is definitively rejected, so an
 * ordinary session expiry produces this while the client still reads as logged
 * in. Shared because both order fetchers key behaviour on it.
 */
export const NO_USER_ERROR_CODE = '42215'
